module.exports = __webpack_public_path__ + "static/media/icon-shijian.9584b2e3.svg";